import React from "react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { AddressFields } from "@/components/AddressFields";
import { missingInvoiceData } from "@/lib/applyVisura";

export const billingMissing = (b) => missingInvoiceData(b);

const F = ({ label, k, b, setB, cls = "" }) => <div className={cls}><Label className="text-xs">{label}</Label>
  <Input className="mt-1 h-9" value={b[k] || ""} onChange={(e) => setB({ ...b, [k]: e.target.value })} data-testid={`sim-bill-${k}`} /></div>;

const empty = (o, k) => !String(o?.[k] || "").trim();

export const SimBillingStep = ({ b, setB, orig }) => {
  const missing = billingMissing(b);
  const need = (k) => empty(orig, k);
  const needAddr = ["address", "zip", "city", "province"].some(need);
  const needPec = need("pec") && need("sdi");
  const lk = (k) => (orig?._locked && !need(k) ? orig[k] : b[k]);
  return <div className="space-y-2" data-testid="sim-billing-step">
    <p className="text-sm">Per emetterti la fattura mancano alcuni dati: li salviamo nella tua anagrafica, una volta sola.</p>
    {missing.length > 0 && <p className="text-xs text-amber-600" data-testid="sim-bill-missing">Mancano: {missing.join(" · ")}</p>}
    <div className="grid grid-cols-2 lg:grid-cols-4 gap-2">
      {need("company_name") && <F label="Ragione sociale *" k="company_name" b={b} setB={setB} cls="col-span-2" />}
      {need("vat_number") && <F label="Partita IVA *" k="vat_number" b={b} setB={setB} />}
      {need("vat_number") && need("fiscal_code") && <F label="Codice fiscale" k="fiscal_code" b={b} setB={setB} />}
      {needPec && <F label="PEC" k="pec" b={b} setB={setB} cls="col-span-2" />}
      {needPec && <F label="Codice SDI" k="sdi" b={b} setB={setB} />}
    </div>
    {needPec && <p className="text-xs text-muted-foreground">Serve almeno uno tra PEC e codice SDI.</p>}
    {needAddr && <><p className="text-xs text-muted-foreground">Sede legale:{orig?._locked && " i dati già registrati restano quelli salvati (per cambiarli apri un ticket in Assistenza), completa solo quelli mancanti."}</p>
    <div className="grid lg:grid-cols-2 gap-2 items-start"><AddressFields prefix="sim-bill" required values={{ address: lk("address"), cap: lk("zip"), city: lk("city"), province: lk("province") }}
      onChange={(p) => setB((x) => ({ ...x, ...(p.address !== undefined && { address: p.address }), ...(p.cap !== undefined && { zip: p.cap }), ...(p.city !== undefined && { city: p.city }), ...(p.province !== undefined && { province: p.province }) }))} /></div></>}
  </div>;
};
